"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addEventListenerWithContext = exports.dispatchWithContext = void 0;
const AsyncStack_1 = require("./AsyncStack");
const _lib_1 = require("./_lib");
const originalAddEventListerner = EventTarget.prototype.addEventListener;
const originalDispatchEvent = EventTarget.prototype.dispatchEvent;
const stackByEvent = new WeakMap();
const dispatchWithContext = function (event) {
    const stack = AsyncStack_1.AsyncStack.getCurrent();
    stackByEvent.set(event, stack);
    return originalDispatchEvent.call(this, event);
};
exports.dispatchWithContext = dispatchWithContext;
const addEventListenerWithContext = function (event, callback, options) {
    const wrappedCallback = function (event) {
        const stackWhenDispatched = stackByEvent.get(event) || AsyncStack_1.AsyncStack.Global;
        return (0, _lib_1.runInStack)(stackWhenDispatched, () => {
            // @ts-ignore
            return callback.call(this, event);
        });
    };
    return originalAddEventListerner.call(this, event, wrappedCallback, options);
};
exports.addEventListenerWithContext = addEventListenerWithContext;
//# sourceMappingURL=Events.js.map